import { render, staticRenderFns } from "./UsersFilters.vue?vue&type=template&id=2c61d8e4&scoped=true&"
import script from "./UsersFilters.vue?vue&type=script&lang=js&"
export * from "./UsersFilters.vue?vue&type=script&lang=js&"
import style0 from "./UsersFilters.vue?vue&type=style&index=0&id=2c61d8e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c61d8e4",
  null
  
)

export default component.exports